<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Holiday } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditHoliday from './EditHoliday.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        holiday: Holiday;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="holiday">
        <EditHoliday
            v-if="hasPermission(Permission.HOLIDAYS_UPDATE)"
            :holiday="holiday"
        />
        <Delete
            v-if="hasPermission(Permission.HOLIDAYS_DELETE)"
            :route="route('v2.salary.holidays.destroy', holiday.id)"
            :query-key="[QueryKey.HOLIDAYS]"
            header="holidays.delete.title"
            description="holidays.delete.content"
        />
    </DataTableActions>
</template>
